import ContentSections from '@/components/Sections/ContentSections'
import Sub from './Sub'
import classes from './Subscriptions.module.scss'
import Link from 'next/link'

export default function SubscriptionsPage({ subsData, accountSettings }) {
  const renderEmptySubscriptionsContent = () => {
    if (
      accountSettings.emptySubscriptionsContent &&
      accountSettings.emptySubscriptionsContent.length > 0
    ) {
      return (
        <ContentSections sections={accountSettings.emptySubscriptionsContent} />
      )
    }

    return (
      <>
        <h4>No active subscriptions</h4>
        <h5>
          <Link href="/pages/choose-your-plan">Choose your plan.</Link>
        </h5>
      </>
    )
  }

  const renderSubscriptionsContent = () => {
    return subsData.map((sub, index) => {
      return (
        <div className={classes['sub-container']} key={sub.subscription_id}>
          <Sub
            key={sub.subscription_id}
            defaultOpen={index === 0}
            subscription={sub}
            accountSettings={accountSettings}
          ></Sub>
        </div>
      )
    })
  }

  return (
    <div className={classes['subscriptions']}>
      {subsData.length > 0
        ? renderSubscriptionsContent()
        : renderEmptySubscriptionsContent()}
    </div>
  )
}
